import React, { useEffect, useRef } from 'react';

function RightSidebarItemsWrapper(_ref) {
  var children = _ref.children;
  var elementRef = useRef();
  useEffect(function () {
    if (elementRef) {
      var divElement = elementRef.current;
      var parentEl = divElement.parentElement;
      parentEl.style.overflowY = "scroll";
    }
  }, []);
  return React.createElement("div", {
    ref: elementRef,
    id: "right-sidebar"
  }, children);
}

export default RightSidebarItemsWrapper;